// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {ReactNode, useCallback, useEffect, useState} from 'react';
import cn from 'classnames';
import {Svg} from './svg';
import styles from './notification.module.less';

interface i_notification_props {
    children: ReactNode;
    cls?: string;
    btn_text?: string;
    btn_icon?: JSX.Element;
    on_click?: ()=>void;
    keep_on_scroll?: boolean;
}

export const Notification = (props: i_notification_props)=>{
    const {btn_text = 'OK', on_click, children, btn_icon,
        keep_on_scroll} = props;
    const [visible, set_visible] = useState(true);
    const hide = useCallback(()=>{
        set_visible(false);
        window.removeEventListener('scroll', hide);
    }, []);
    const handle_click = useCallback(()=>{
        on_click && on_click();
        hide();
    }, [on_click, hide]);
    useEffect(()=>{
        if (!keep_on_scroll)
            window.addEventListener('scroll', hide);
    }, [hide, keep_on_scroll]);
    const cls = cn(styles.notification, props.cls, !visible && styles.hidden,
        visible && styles.shown);
    return <div className={cls}>
      <div>{children}</div>
      <a className={cn(styles.btn, btn_icon && styles.btn_icon)}
        onClick={handle_click}>
        {btn_icon ? <Svg icon={btn_icon}/> : btn_text}
      </a>
    </div>;
};
